import React, { useState } from 'react';
import classNames from 'classnames';
import { Col, Row } from 'react-bootstrap';
import { useDispatch } from 'react-redux';
import { Button } from '@praktio/common-ui';
import { Link, NavigateFunction } from 'react-router-dom';

import { getLearnerCertificate } from '../../../ducks/learner';

import './CourseTile.scss';

interface IProps {
  course: ICourse;
  courseAssignments?: ICourseAssignment[];
  navigate: NavigateFunction;
  expired?: boolean;
}

const CourseTile = ({ course, courseAssignments, navigate, expired }: IProps) => {
  const dispatch = useDispatch();

  const [downloadDisabled, setDownloadDisabled] = useState(false);

  const { _id, certUponComplete, progress, logo } = course;
  const courseId = _id || '';
  const title = course.title || '';
  const assignment = courseAssignments?.find((a) => a.courseId === courseId);
  const expiration = assignment?.expiration;
  let expiredText = '';
  let date: Date | undefined;
  if (expiration) {
    date = new Date(expiration);
  }

  if (date) {
    expiredText = `Access expire${expired ? 'd' : 's'} ${date.toLocaleDateString()}`;
  }

  const downloadCertificate = (event: React.MouseEvent | undefined, courseId: string) => {
    event?.preventDefault();
    event?.stopPropagation();
    setDownloadDisabled(true);
    (dispatch(getLearnerCertificate({ courseId, title })) as any).then(() =>
      setDownloadDisabled(false),
    );
  };

  const formattedProgress = `${(progress || 0).toLocaleString(undefined, {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  })}%`;
  return (
    <li className={classNames('CourseTile', { expired })}>
      <Link
        to={`/courses/${courseId}`}
        className="CourseTile-link"
        onClick={(e) => expired && e.preventDefault()}
      >
        <div className="CourseTile-img">
          <img src={(logo as string) || '/course-library-default.png'} alt="" />
          {progress === 100 && (
            <div className="complete-mark">
              <span className="material-icons">done</span>
            </div>
          )}
        </div>
        <Row className="CourseTile-body px-4">
          <Col xs={8} className="CourseTile-body-left">
            <div className="CourseTile-title">{title}</div>
            <div className="CourseTile-percent">
              <div className="CourseTile-percent-bar">
                <div
                  className="CourseTile-percent-bar-fill"
                  style={{ width: (progress || 0) + '%' }}
                ></div>
              </div>
              <div className="CourseTile-percent-text">{`${formattedProgress}`}</div>
            </div>
          </Col>
          <Col xs={4} className="CourseTile-body-right d-flex flex-column">
            {!!certUponComplete && progress === 100 && (
              <div className="download-certificate-wrapper d-flex justify-content-end">
                <Button
                  disabled={downloadDisabled}
                  aria-pressed={downloadDisabled}
                  aria-disabled={downloadDisabled}
                  showSpinner={downloadDisabled}
                  onClick={(event) => downloadCertificate(event, courseId)}
                  className="download-certificate-button"
                >
                  <span className="material-icons">download</span>
                  <span className="button-text"> Certificate</span>
                </Button>
              </div>
            )}

            {!!expiredText && (
              <div className="CourseTile-expiration-text text-right">{expiredText}</div>
            )}
          </Col>
        </Row>
      </Link>
    </li>
  );
};

export default CourseTile;
